module.exports = __webpack_public_path__ + "img/Phone_White@3x.03239498.png";